
import {whenReady} from "./../general/Util.js";
import {getViewControllerName} from './../general/Util.js';

export function keepFilterForChips() {
	const alistFilters = [
		'brand-',
		'theme-',
		'badge-',
		'pseries-',
		'size-',
		'color-',
		'saison-',
		'prize-',
		'sale-1',
		'new-1',
		'sortfield-',
		'sortorder-'
	];

	const linkEls = document.querySelectorAll( '[data-pimid]' );
	linkEls.forEach( linkEl => {
		linkEl.addEventListener( 'click', ( ev ) => {
			ev.preventDefault();

			const urlParts = window.location.href.split( '/' );
			let toUrl = linkEl.getAttribute( 'href' );

			const filterUrl = linkEl.getAttribute( 'data-filterUrl' );
			if ( filterUrl ) {
				toUrl += filterUrl;
			}

			let markenshop = false;
			if ( toUrl.includes( '-markenshop' ) ) {
				markenshop = true;
			}

			for ( let i = 0; i < urlParts.length; i++ ) {

				const part = urlParts[i];
				if ( markenshop && part === 'sortfield-neu' ) {
					urlParts[i] = 'sortfield-mneu';
				}

				if ( part.startsWith( 'brand-' ) && linkEl.classList.contains( 'en_mdl_brandslider__item-inner' ) ) {
					urlParts.splice( i, 1 );
				}

				for ( let j = 0; j < alistFilters.length; j++ ) {
					if ( part.startsWith( alistFilters[j] ) && ! toUrl.includes( '/' + alistFilters[j] ) ) {
						toUrl += '/' + urlParts[i];
					}
				}
			}
			window.location.href = toUrl;
		} )
	} );
}

export function setPredefinedFilterAttribute() {

	const linkEls = Array.from( document.querySelectorAll( 'a[data-pimid]' ) );
	const formBody = new FormData();
	linkEls.forEach( ( linkEl ) => {
		formBody.append( 'pimids[]', linkEl.dataset.pimid );
	} );

	return fetch( '/index.php?cl=searchservice_ajax&fnc=getPredefinedFilters', {
		method: 'POST',
		body: formBody
	} ).then( async( res ) => {
		if ( res.ok ) {
			return await res.json();
		}

		return Promise.reject( await res.json() );
	} ).then( ( result ) => {

		linkEls.forEach( linkEl => {
			const pimId = linkEl.dataset.pimid;
			if ( pimId in result ) {
				if ( result[ pimId ] ) {
					linkEl.setAttribute( 'data-filterUrl', result[ pimId ] );
				}
			}
		} );

		return result;
	} ).catch( ( err ) => {
		console.error( err ); // eslint-disable-line no-console
		return false;
	} );
}

whenReady.then( () => {

	const v_cl = getViewControllerName();
	switch ( v_cl ) {
		case 'alist':
		case 'searchservice_alist_filter':
			keepFilterForChips();
			setPredefinedFilterAttribute()
			break;
	}
} );
